import { Navigate, Outlet } from 'react-router-dom';
import { Flex, Image } from '@chakra-ui/react';
import BrandLogo from 'app/components/Branding/BrandLogo';
import useAuthContext from 'app/hooks/useAuthContext';
import useSignOut from 'app/hooks/useSignOut';
import { getBlankPath } from 'app/utils/routes';
import appEnv from 'app/config/appEnv';

const S3_PUBLIC_BUCKET_URL = appEnv.VITE_S3_PUBLIC_BUCKET_URL;

function OnboardingLayout() {
  const { user } = useAuthContext();
  const { mutate: signOut } = useSignOut(user?.role);

  if (user) {
    if (user?.role === 'ASLAN_ADMIN') {
      signOut();
    }
    return <Navigate to={getBlankPath()} replace />;
  }

  return (
    <Flex h="100vh">
      <Flex flexDirection="column" flexGrow={1} minW="60%" p="40px" gap="40px" bg="white">
        <BrandLogo w="138px" />
        <Flex flexDirection="column" flexGrow={1}>
          <Outlet />
        </Flex>
      </Flex>
      <Image
        src={`${S3_PUBLIC_BUCKET_URL}/assets/onboarding_side_image.jpg`}
        flexShrink={1}
        objectFit="cover"
        minW="0"
        display={{ base: 'none', lg: 'block' }}
      />
    </Flex>
  );
}

export default OnboardingLayout;
